import React from 'react'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

class ContactForm extends React.Component<ContactFormProps, ContactFormState> {

  state = { name: "", fromAddress: "", subject: "", message: "" }

  handleChange = (variableName: string) => (event: React.FormEvent<EventTarget>) => {
    let target = event.target as HTMLInputElement;
    this.setState({ [variableName]: target.value } as any);
  }

  handleSubmit = (event: React.FormEvent<EventTarget>) => {

    if (this.state.fromAddress == "") {
      alert('Please enter your email');
    } else if (this.state.name == "") {
      alert('Please enter your name');
    } else if (this.state.message == "") {
      alert('Please enter a message');
    } else {
      fetch("https://islandmalthouse.azurewebsites.net/SendEmail", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.state)
      }).then((response) => {
        if (response.ok) {
          alert('Your message was sent successfully');
          this.setState({ name: "", fromAddress: "", subject: "", message: "" });
          return;
        }
        else {
          alert('The message could not be sent');
        }
      })
    }
    event.preventDefault();
  }

  render() {
    return (
      <Container className="body-content">
        <p>Phone: +1 (902) 964-3022</p>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group controlId="exampleForm.ControlInput0">
            <Form.Label>Your Name (required)</Form.Label>
            <Form.Control value={this.state.name} onChange={this.handleChange('name')} />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlInput1">
            <Form.Label>Your Email (required)</Form.Label>
            <Form.Control type="email" placeholder="name@example.com" value={this.state.fromAddress} onChange={this.handleChange("fromAddress")} />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlInput2">
            <Form.Label>Subject</Form.Label>
            <Form.Control value={this.state.subject} onChange={this.handleChange("subject")} />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlTextarea3">
            <Form.Label>Your Message (required)</Form.Label>
            <Form.Control as="textarea" rows="3" value={this.state.message} onChange={this.handleChange("message")} />
          </Form.Group>
          <Button type="submit">
            Submit
            </Button>
        </Form>
      </Container>
    );
  }
}

interface ContactFormProps { }

interface ContactFormState {
  name: string,
  fromAddress: string,
  subject: string,
  message: string
}

export default ContactForm